import { render, staticRenderFns } from "./MaterialManageAdd.vue?vue&type=template&id=79b67745&scoped=true&"
import script from "./MaterialManageAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialManageAdd.vue?vue&type=script&lang=js&"
import style0 from "./MaterialManageAdd.vue?vue&type=style&index=0&id=79b67745&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b67745",
  null
  
)

export default component.exports